<template>
  <nav
    class="navbar navbar-area navbar-area-2 navbar-expand-lg"
    :class="{ 'sticky-active': scrollPosition >= 445 }"
  >
    <div class="container nav-container navbar-bg">
      <div class="responsive-mobile-menu">
        <button
          class="menu toggle-btn d-block d-lg-none"
          data-target="#itech_main_menu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="icon-left"></span>
          <span class="icon-right"></span>
        </button>
      </div>
      <div style="padding-left: 8%; padding-right: 28%;">
        <router-link to="/"
          ><img
            :src="require('@/assets/img/Smaco-Logo-banner-NoBackground150.png')"
            alt="img"
        /></router-link>
      </div>
      <div class="nav-right-part nav-right-part-mobile">
        <a class="search-bar-btn" id="search-bar-btn" href="javascript:void(0)">
          <i class="fa fa-search"></i>
        </a>
      </div>
      <div class="collapse navbar-collapse" id="itech_main_menu">
        <ul class="navbar-nav menu-open text-lg-center">                
          <li><router-link to="/">Inicio</router-link></li>
          <li><router-link to="/service">Servicios</router-link></li>
          <li><router-link to="/about">Acerca de Nosotros</router-link></li>
          <li><router-link to="/contact-us">Contáctanos</router-link></li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Header",
  data: function() {
    return {
      scrollPosition: null
    };
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);

    const menu = document.querySelector(".navbar-area .menu");
    const navbarCollapse = document.querySelector(
      ".navbar-area .navbar-collapse"
    );

    menu.addEventListener("click", function() {
      this.classList.toggle("open");
      navbarCollapse.classList.toggle("sopen");
    });

    const menuItems = document.querySelectorAll(
      ".navbar-nav .menu-item-has-children"
    );

    menuItems.forEach(menuItem => {
      const subMenu = menuItem.querySelector(".sub-menu");
      if (subMenu) {
        menuItem.addEventListener("click", function() {
          if (subMenu.style.display === "block") {
            subMenu.style.display = "none";
          } else {
            subMenu.style.display = "block";
          }
        });
      }
    });
  }
};
</script>

<style>
.sticky-active {
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue